import React, { useState, useContext } from "react";
import axios from "axios";
import DataTable, { createTheme } from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HistoryIcon from '@mui/icons-material/History';
import RefreshIcon from '@mui/icons-material/Refresh';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { divisionUnitData, statusData, authorizationstatusData, historicalrequeststatusData } from "variables/lists/meters";
import { metertext } from "variables/meters";
import useMetersTable from "./useMetersTable.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ReactLoading from "react-loading";
import "./table.css";
import ViewMeterDataDialog from "./ViewMeterDataDialog";
import HistoricDataDialog from "./HistoricDataDialog.js";
import moment from "moment";
import { putApiMeterRequest } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
  color: grey;
`;
const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const EllipsisCellText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const EllipsisCellTextRed = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #C53F3F;
  font-weight: bold;
`;

const EllipsisCellTextGreen = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #91C73C;
  font-weight: bold;
`;

createTheme('solarized', {
  text: {
    primary: '#000000',
    secondary: '#000000',
  },
  background: {
    default: '#e6e5eb',
  },
  context: {
    background: '#e6e5eb',
    text: '#000000',
  },
  divider: {
    default: '#FFFFFF',
  },
  action: {
    button: 'rgba(0,0,0,.54)',
    hover: 'rgba(0,0,0,.08)',
    disabled: 'rgba(0,0,0,.12)',
  },
}, 'dark');


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const useStyles = makeStyles(styles);

const RTMeters = () => {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { gridState, refetch, setSelectedMeters, energychoice } = useMetersTable();
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;

  const [openMeterData, setOpenMeterData] = useState(false);
  const [openMeterHistorical, setOpenMeterHistorical] = useState(false);
  const [meter, setMeter] = useState(null);

  let datameters = gridState.data;

  console.log(currentusertype);

  const classes = useStyles();

  const viewMeterData = (row) => async () => {
    let obj = datameters.find((o) => o.uuid === row.uuid);
    if (obj) {
      setMeter(obj);
      handleViewMeterDataOpen();
    }
  };

  const viewMeterHistorical = (row) => async () => {
    let obj = datameters.find((o) => o.uuid === row.uuid);
    if (obj) {
      setMeter(obj);
      handleViewMeterHistoricalOpen();
    }
  };

  const calculatePercent = (row) => {
    let percent = 0;
    let percentexist = false;
    if (row.distribution) {
      row.distribution.map((site) => {
        if (site.divisionunit === 'percent' && site.divisionvalue) {
          percentexist = true;
          percent += Number(site.divisionvalue.replace(',', '.'));
        }
      });
    }
    if (!percentexist)
      return -1;
    return percent;
  }

  const calculateSqrMtr = (row) => {
    let sqrmtr = 0;
    let sqrmtrexist = false;
    if (row.distribution) {
      row.distribution.map((site) => {
        if (site.divisionunit === 'sqrmtr' && site.divisionvalue) {
          sqrmtrexist = true;
          sqrmtr += Number(site.divisionvalue.replace(',', '.'));
        }
      });
    }
    if (!sqrmtrexist)
      return -1;
    return sqrmtr;
  }

  const sortLoadcurvestatus = (rowA, rowB) => {
    let a = rowA.loadcurvestatus || '0';
    let b = rowB.loadcurvestatus || '0';

    if (a === 'actif')
      a = '2';
    else
      a = '1' + a;
    if (b === 'actif')
      b = '2';
    else
      b = '1' + b;

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSubmitResetEnedisAMR = (row) => async () => {
    axios
      .put(
        putApiMeterRequest(row.amrid, 'resetenedis'),
        {
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Relance faite");
          refetch();
        }
        else
          setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });

  };


  const columns = [
    {
      name: metertext.meternumber,
      selector: (row) => row.meternumber,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.meternumber
    },
    {
      name: metertext.status,
      selector: (row) => row.details?.status,
      sortable: true,
      width: "8rem",
      cell: (row) => row.details?.status ?
        <div style={{ color: statusData.find((x) => x.id == row.details.status).color, fontWeight: "bold" }}>
          {statusData.find((x) => x.id == row.details.status).name}
        </div> : <></>
    },
    {
      name: metertext.serialnumber,
      selector: (row) => row.details?.serialnumber,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.details?.serialnumber
    },
    {
      name: metertext.key,
      selector: (row) => row.details?.clef,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.details?.clef
    },
    {
      name: metertext.segment,
      selector: (row) => row.details?.segment,
      sortable: true,
      maxWidth: "8rem",
      omit: energychoice !== 'electricity',
      cell: (row) => row.details?.segment,
    },
    {
      name: metertext.cja,
      selector: (row) => row.details?.cja,
      sortable: true,
      maxWidth: "7rem",
      omit: energychoice !== 'gas',
      cell: (row) => row.details?.cja,
    }
    ,
    {
      name: metertext.diameter,
      selector: (row) => row.details?.diameter,
      sortable: true,
      maxWidth: "7rem",
      omit: energychoice !== 'water',
      cell: (row) => row.details?.diameter,
    },
    {
      name: metertext.account,
      selector: (row) => row.accountid,
      sortable: true,
      maxWidth: "7rem",
      cell: (row) => groupInfoListById["" + row.accountid] || ""
    },
    {
      name: metertext.address,
      selector: (row) => row.details?.address?.description,
      sortable: true,
      maxWidth: "10rem",
      //maxWidth: "13rem",
      cell: (row) => <Tooltip title={row.details?.address?.description}>
        <EllipsisCellText>{row.details?.address?.description}</EllipsisCellText>
      </Tooltip>
    },
    {
      name: metertext.description,
      selector: (row) => row.details?.description,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => <Tooltip title={row.details?.description}>
        <EllipsisCellText>{row.details?.description}</EllipsisCellText>
      </Tooltip>
    },
    {
      name: metertext.distribution,
      selector: (row) => (row.distribution && row.distribution.length) == 1 ?
        groupInfoListById["" + row.distribution[0].groupid] :
        (!row.distribution || row.distribution.length == 0) ?
          '00000000' : '00000000' + row.distribution.length, //just a trick to sort it at the beginning
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => (row.distribution && row.distribution.length) == 1 ?
        groupInfoListById["" + row.distribution[0].groupid] :
        (!row.distribution || row.distribution.length == 0) ?
          'Aucune distribution' : row.distribution.length + ' distributions'
    },
    {
      name: metertext.totaldistributionpercent,
      selector: (row) => calculatePercent(row),
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => calculatePercent(row) == -1 ? '' : new Intl.NumberFormat('fr-FR').format(calculatePercent(row)) + '%'
    },
    {
      name: metertext.totaldistributionsqmtr,
      selector: (row) => calculatePercent(row),
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => calculateSqrMtr(row) == -1 ? '' : new Intl.NumberFormat('fr-FR').format(calculateSqrMtr(row)) + 'm²'
    },
    {
      name: metertext.authorizationstatus,
      selector: (row) => row.authorizationstatus,
      sortable: true,
      width: "8rem",
      cell: (row) => row.authorizationstatus ?
        <div style={{ color: authorizationstatusData.find((x) => x.id == row.authorizationstatus).color, fontWeight: "bold" }}>
          {authorizationstatusData.find((x) => x.id == row.authorizationstatus).name}
        </div> : <></>
    },
    {
      name: metertext.monthlydatafrequency,
      omit: energychoice !== 'gas',
      selector: (row) => row.monthlydatafrequency,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.monthlydatafrequency,
    },
    {
      name: metertext.monthlydatastatus,
      omit: energychoice !== 'electricity' && energychoice !== 'gas',
      selector: (row) => row.details?.monthlyconsumption,
      sortable: true,
      width: "8rem",
      cell: (row) => !row.details?.monthlyconsumption ?
        <div style={{ color: '#C53F3F', fontWeight: "bold" }}>
          Non activée
        </div> :
        row.monthlyerror ?
          <Tooltip title={row.monthlyerror}>
            <EllipsisCellTextRed>{row.monthlyerror}</EllipsisCellTextRed>
          </Tooltip> :
          <div style={{ color: '#91C73C', fontWeight: "bold" }}>
            Active
          </div>
    },
    {
      name: metertext.monthlydatadate,
      omit: energychoice !== 'electricity' && energychoice !== 'gas',
      selector: (row) =>
        row.lastmonthlyconsumption && moment(row.lastmonthlyconsumption).isValid()
          ? moment(row.lastmonthlyconsumption).utc().format("DD/MM/YYYY")
          : "",
      sortable: true,
      maxWidth: "8rem",
      cell: (row) =>
        row.lastmonthlyconsumption && moment(row.lastmonthlyconsumption).isValid()
          ? moment(row.lastmonthlyconsumption).utc().format("DD/MM/YYYY")
          : "",
    },
    {
      name: metertext.loadcurvestatus,
      omit: energychoice !== 'electricity',
      selector: (row) => row.loadcurvestatus,
      sortable: true,
      sortFunction: sortLoadcurvestatus,
      width: "8rem",
      cell: (row) => row.loadcurvestatus === 'actif' ?
        <div style={{ color: '#91C73C', fontWeight: "bold" }}>
          Active
        </div> :
        <Tooltip title={row.loadcurvestatus}>
          <EllipsisCellTextRed>{row.loadcurvestatus}</EllipsisCellTextRed>
        </Tooltip>
    },
    {
      name: metertext.dailydatadate,
      omit: energychoice !== 'gas',
      selector: (row) => row.lastdailyconsumption,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) =>
        row.lastdailyconsumption && moment(row.lastdailyconsumption).isValid()
          ? moment(row.lastdailyconsumption).utc().format("DD/MM/YYYY")
          : "",
    },
    {
      name: metertext.historicalrequeststatus,
      omit: (energychoice !== 'electricity' && energychoice !== 'gas') || currentusertype != 1,
      selector: (row) => row.historicalrequest,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.historicalrequest ? row.historicalrequest.status ?
        historicalrequeststatusData.find((x) => x.id == row.historicalrequest.status).name :
        historicalrequeststatusData.find((x) => x.id == 1).name
        : historicalrequeststatusData.find((x) => x.id == 0).name
    },
    {
      name: '',
      sortable: false,
      width: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            {
              (energychoice === 'electricity' || energychoice === 'gas') &&
              <>
                <Tooltip title="Données du compteur">
                  <Button
                    onClick={viewMeterData(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <VisibilityIcon fontSize="large" />
                  </Button>
                </Tooltip>

              </>
            }
            {
              (currentusertype == 1 && (energychoice === 'electricity' || energychoice === 'gas') && row.authorizationstatus == 1 && row.amr) &&

              <Tooltip title="Récupérer un historique">
                <Button
                  onClick={viewMeterHistorical(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <HistoryIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {
              (currentusertype == 1 && (energychoice === 'electricity') && row.authorizationstatus == 1 && row.amr) &&
              <Tooltip title="Relancer les réquêtes ENEDIS">
                <Button
                  onClick={handleSubmitResetEnedisAMR(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <RefreshIcon fontSize="large" />
                </Button>
              </Tooltip>

            }
          </div>
        </>
      ),
    },
  ];

  const subcolumns = (exportarray) => {
    let columns = [
      {
        name: metertext.group,
        selector: (row) => groupInfoListById["" + row.groupid],
        sortable: true,
        width: "12rem",
        cell: (row) => groupInfoListById["" + row.groupid],
      },
      {
        name: metertext.divisionunit,
        selector: (row) => row.divisionunit,
        sortable: true,
        width: "8rem",
        cell: (row) => divisionUnitData.find((x) => x.id == row.divisionunit)?.name
      },
      {
        name: metertext.divisionvalue,
        selector: (row) => row.divisionvalue,
        sortable: true,
        width: "8rem",
        cell: (row) => new Intl.NumberFormat('fr-FR').format((row.divisionvalue).replace(',','.')),
      },
      {
        name: metertext.sitestatus,
        selector: (row) => row.status,
        sortable: true,
        width: "8rem",
        cell: (row) => row.status ?
          <div style={{ color: statusData.find((x) => x.id == row.status).color, fontWeight: "bold" }}>
            {statusData.find((x) => x.id == row.status).name}
          </div> : <></>
      },
      {
        name:
          <UploadButton type="button">
            <ExportTableToCSV dataarray={exportarray} />
          </UploadButton>,
        sortable: false,
        width: "8rem",
        cell: (row) => ''
      },
    ];

    return columns;
  }

  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = data.distribution;
    // console.log(data);
    let exportarray = [];
    if (datadisplay) {
      exportarray = datadisplay.map((row) => {
        let sitetoexport = {};
        sitetoexport[metertext.group] = groupInfoListById["" + row.groupid];
        sitetoexport[metertext.idgroup] = row.groupid;
        sitetoexport[metertext.divisionunit] = divisionUnitData.find((x) => x.id == row.divisionunit)?.name;
        sitetoexport[metertext.divisionvalue] = new Intl.NumberFormat('fr-FR').format((row.divisionvalue).replace(',','.'));
        sitetoexport[metertext.sitestatus] = statusData.find((x) => x.id == row.status)?.name;
        return sitetoexport;
      });
    }
    //  console.log(exportarray);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucune distribution à afficher</NoData>}
          noHeader={true}
          columns={subcolumns(exportarray)}
          persistTableHead
          data={datadisplay}
          striped={true}
        //theme="solarized"
        />
      </Container>
    );
  };


  const handleViewMeterDataOpen = () => {
    setOpenMeterData(true);
  };
  const handleViewMeterDataClose = () => {
    setOpenMeterData(false);
  };

  const handleViewMeterHistoricalOpen = () => {
    setOpenMeterHistorical(true);
  };
  const handleViewMeterHistoricalClose = () => {
    setOpenMeterHistorical(false);
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedMeters(selection.selectedRows);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>{energychoice === 'choice' ? 'Choisir une énergie' : 'Aucun compteur à afficher pour cette énergie'}</NoData>}
        // noHeader={true}
        title="Compteurs"
        columns={columns}
        persistTableHead
        pagination
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        subHeader
        progressPending={gridState.loading}
        progressComponent={<div><LoadingDiv><ReactLoading
          type={"bars"}
          color={"#91c241"}
          height={"10%"}
          width={"10%"}
        /></LoadingDiv></div>}
        //highlightOnHover
        //pointerOnHover
        expandOnRowClicked
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleViewMeterDataClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openMeterData}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewMeterDataClose}>
          Données de {meter?.meternumber}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewMeterDataDialog
            meter={meter}
            closeModal={handleViewMeterDataClose}
            refetch={refetch}
            energy={energychoice}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewMeterHistoricalClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openMeterHistorical}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewMeterHistoricalClose}>
          Demande d'historique pour {meter?.meternumber}
        </CustomDialogTitle>
        <DialogContent dividers>
          <HistoricDataDialog
            meter={meter}
            closeModal={handleViewMeterHistoricalClose}
            refetch={refetch}
            energy={energychoice}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      {/* <Dialog
        onClose={handleViewSubBillClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openSubBill}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewSubBillClose}>
          Détails de la facture
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewSubBillDialog
            subbill={subbill}
            closeModal={handleViewSubBillClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewBillClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openBill}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewBillClose}>
          Création d'un état de paiement
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditEtatPaiementDialog
            bill={bill}
            closeModal={handleViewBillClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog> */}
    </>
  );
};

export default RTMeters;
